import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import Icon from "../../../Components/Icon";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateProduct = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Produkte Verwalten</Text>

                <Text type="itemtext">
                    Produkte sind das A und O der Kassenapp. Sie werden benötigt,
                    um am Kassenterminal Bestellungen erfassen zu können.
                </Text>

                <SmallImage src={"instructions/product-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Kategorien-Auswahl</Text>
                    <Text type="title">2. Neues Produkt in Kategorie erstellen</Text>
                    <Text type="title">3. Alle Produkte</Text>
                    <Text type="title">4. Editieren / Löschen</Text>
                </div>

                {/* 1. Kategorien-Auswahl */}
                <ChapterToggler title="1. Kategorien-Auswahl">
                    <Text type="itemtext">
                        Hier werden alle aktiven Kategorien angezeigt.
                        Jedes Produkt muss einer Kategorie zugewiesen sein.
                    </Text>

                    <Text type="itemtext">
                        Durch das Anklicken einer Kategorie werden alle Produkte
                        dieser Kategorie sowie der Erstellen-Button angezeigt.
                    </Text>

                    <Text type="itemtext">
                        Ist keine Kategorie ausgewählt, bleibt die Produktliste leer
                        und der Erstellen-Button ist nicht sichtbar.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/product-no-category.png"}
                        smallSize="w-1/3"
                        subtitle="Keine Kategorie ausgewählt"
                    />
                </ChapterToggler>

                {/* 2. Neues Produkt erstellen */}
                <ChapterToggler title="2. Neues Produkt erstellen">
                    <Text type="itemtext">
                        Der Erstellen-Button ist nur sichtbar, wenn eine Kategorie ausgewählt wurde.
                        Das Produkt wird automatisch dieser Kategorie zugeordnet.
                    </Text>

                    <Text type="itemtext">
                        Durch das Drücken auf den Knopf öffnet sich folgendes Formular:
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/product-create.png"}
                        smallSize="w-1/3"
                        subtitle="Produkt Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgende Eigenschaften können definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Name:</b> Name des Produkts
                    </Text>
                    <Text type="itemtext">
                        <b>Preis:</b> Preis des Produkts
                    </Text>
                    <Text type="itemtext">
                        <b>EAN:</b> EAN-Code des Produkts, sichtbar in der Statistik als Barcode
                    </Text>
                    <Text type="itemtext">
                        <b>Rabattfähig:</b> Definiert, ob das Produkt durch Rabatte reduziert werden darf
                    </Text>
                    <Text type="itemtext">
                        <b>Farbe:</b> Farbe des Produkts an der Kasse.
                        Überschreibt die Kategoriefarbe.
                        Bei „Transparent“ wird die Kategoriefarbe verwendet.
                    </Text>
                </ChapterToggler>

                {/* 3. Alle Produkte */}
                <ChapterToggler title="3. Alle Produkte">
                    <Text type="itemtext">
                        Hier werden alle Produkte der aktuell ausgewählten Kategorie angezeigt.
                        Ist keine Kategorie ausgewählt, bleibt die Liste leer.
                    </Text>
                </ChapterToggler>

                {/* 4. Editieren / Löschen */}
                <ChapterToggler title="4. Editieren / Löschen">
                    <Text type="itemtext">
                        Diese Knöpfe ermöglichen es, Produkte zu bearbeiten oder zu löschen.
                        Beim Bearbeiten öffnet sich dasselbe Formular wie beim Erstellen.
                    </Text>
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateProduct;
